var map = {
	"./angpao.webp": 2321,
	"./bonus.webp": 2322,
	"./gpi-rebate-m.webp": 2323,
	"./gpi-rebate.webp": 2324,
	"./hublot-watch-2018.webp": 2325,
	"./hublot-watch-2022.webp": 2326,
	"./iphone-13-pro-max.webp": 2327,
	"./iphone-14-pro-max.webp": 2328,
	"./login-to-m.webp": 2329,
	"./login-to.webp": 2330,
	"./mb.webp": 2331,
	"./mg-rebate-m.webp": 2332,
	"./mg-rebate.webp": 2333,
	"./np.webp": 2334,
	"./pointer.webp": 2335,
	"./pp-rebate-m.webp": 2336,
	"./pp-rebate.webp": 2337,
	"./sadface.webp": 2338,
	"./wallet-m.webp": 2339,
	"./wallet.webp": 2340,
	"./wheel-b.webp": 2341,
	"./wheel-btn.webp": 2342,
	"./wheel-indon-b.webp": 2343,
	"./wheel-indon.webp": 2344,
	"./wheel.webp": 2345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 930;